import { create } from "zustand"
import { SIZE_COLOR_MAPS } from "./report-const"
import { barChartStore } from "./_components/bar-chart/bar-chart-store"
import { boxplotVerticalStore } from "./_components/boxplot/boxplot-vertical-store"
import { heatmapStore } from "./_components/heatmap/heatmap-store"
import { langStore } from "@/stores/lang-store"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { getReportDataAPI } from "@/apis/apt-api"
import { boxplotHorizontalStore } from "./_components/boxplot/boxplot-horizontal-store"

export const reportStore = create((set, get) => ({
  // INFO: 컬러 맵핑 후 사용
  customColors: {},

  allUnitUsages: [],
  groupStats: [],
  summary: null,
  unit: "m³",
  axisMaxMap: {},

  startDate: "",
  endDate: "",

  // INFO: 차트의 요소별 컬러 삽입용도
  setCustomColorsMapping: (stats = []) => {
    const customColors = {}
    stats.forEach((c, idx) => {
      customColors[c.apt_size] = SIZE_COLOR_MAPS[idx % SIZE_COLOR_MAPS.length]
    })
    set({ customColors })
    return customColors
  },

  // INFO : 데이터 불러온 후 데이터 삽입
  apiGetReport: async ({ start_date, end_date, resource }) => {
    const { sido, kapt_code } = aptSearchStore.getState().pickApt
    if (!sido && !kapt_code) return

    const { setCustomColorsMapping } = get()
    const { lang } = langStore.getState()

    const { setChart: setBarChart } = barChartStore.getState()
    const { setChart: setBoxplotVerticalChart } = boxplotVerticalStore.getState()
    const { setChart: setBoxplotHorizontalChart } = boxplotHorizontalStore.getState()
    const { setChart: setHearmapChart } = heatmapStore.getState()

    const all = { ko: "전체", en: "All", es: "Todo" }[lang]

    const result = await getReportDataAPI({ sido, kapt_code, start_date, end_date, resource })

    const { all_unit_usages, group_stats, summary, heatmaps, visual_max, unit } = result
    const { boxplot, outliers } = summary

    const customColors = setCustomColorsMapping(group_stats)
    const { axisMaxMap, max } = group_stats.reduce(
      (acc, apt) => {
        acc.axisMaxMap[apt.apt_size] = apt.y_axis_max
        acc.max = Math.max(acc.max, apt.y_axis_max)
        return acc
      },
      { axisMaxMap: {}, max: 0 }
    )
    axisMaxMap.ALL = max

    setBarChart(all, all_unit_usages, customColors)
    setBoxplotVerticalChart(all, { apt_size: all, boxplot, outliers }, customColors)
    setBoxplotHorizontalChart(all, { apt_size: all, boxplot, outliers }, customColors)
    setHearmapChart(heatmaps, visual_max)
    set({
      allUnitUsages: all_unit_usages,
      groupStats: group_stats,
      axisMaxMap,
      summary,
      unit
    })

    return true
  },

  // INFO: 시작일 세팅
  setStartDate: (startDate) => set({ startDate }),
  // INFO: 종료일 세팅
  setEndDate: (endDate) => set({ endDate }),

  reset: () => {
    set({
      cache: {},
      customColors: {},
      allUnitUsages: [],
      groupStats: [],
      axisMaxMap: {},
      summary: null,
      startDate: "",
      endDate: ""
    })
    barChartStore.getState().reset()
    boxplotVerticalStore.getState().reset()
    heatmapStore.getState().reset()
  }
}))
